<template>
    <div class="page">
        <van-nav-bar :title="title" placeholder fixed>
            <template #left>
                <van-icon @click="goback" name="arrow-left" size="22" color="#000" />
            </template>
            <template #right v-if="nowUserID!='xj1'">
                <van-icon @click="goorder" name="ellipsis" size="22" color="#000" />
            </template>
        </van-nav-bar>
        <div class="tim_cont_c " @scroll="scrollEventSay">
            <div v-for="(item, index) in wordList" :key="item.id">
                <div class="tim_time" v-show="index == 0">
                    {{ item.createtime | dateFormat }}
                </div>
                <div v-if="index != 0" class="tim_time">
                    <span v-if="item.createtime - wordList[index - 1].createtime > 5 * 60">
                        {{ item.createtime | dateFormat }}
                    </span>
                </div>

                <div v-if="item.type == 'system'" class="tim_system">
                    <i class="el-icon-warning"></i>
                    <span>
                        {{ item.contactText }}
                    </span>
                </div>

                <div v-if="item.isRevoke" class="tim_revoketip">
                    <i class="el-icon-warning"></i>
                    <span v-if="item.mineMsg">
                        你撤回了一条消息
                    </span>
                    <span v-else>
                        {{title}} 撤回了一条消息
                    </span>
                </div>


                <div class="left_cont_i" v-if="item.mineMsg == false && item.type != 'system' && !item.isRevoke">
                    <img class="avatar" :src="item.avatar" alt="" srcset="">
                    <div v-if="item.type == 'default'" class="xx" style="margin-left: 10px;">
                        {{ item.contactText }}
                    </div>
                    <div v-if="item.type == 'file'" class="file xx" style="margin-left: 10px;">
                        <div class="file_flex">
                            <div class="imgs">
                                <img src="../../assets/tim/fs.png" alt="">
                            </div>
                            <div>
                                <div class="filename">{{ item.fileName | urlCode }}</div>
                                <div class="filesize"> {{ item.fileSize }} </div>
                            </div>
                            <div class="imgsd" @click="download(item)">
                                <img src="../../assets/tim/down.png" alt="">
                            </div>
                        </div>
                    </div>
                    <div v-if="item.type == 'image'" style="margin-left: 10px;">
                        <el-image :preview-src-list="[item.contactText]"
                            style="width: 160px;height: 160px;border-radius: 6px;" :src="item.contactText"></el-image>
                    </div>
                    <div v-if="item.type == 'link_text'"  v-html="item.contactText" class="xx" style="margin-left: 10px;">

                    </div>
                </div>

                <div class="right_cont_i" v-if="item.mineMsg == true && item.type != 'system' && !item.isRevoke">
                    <div class="rig">
                        <img class="avatar" :src="item.avatar" alt="" srcset="">
                        <div v-if="item.type == 'default'" class="xx" style="margin-right: 10px;">
                            {{ item.contactText }}
                            <div class="isread" :class="item.read ? '' : 'cobule'">
                                {{ item.read ? "已读" : "未读" }}
                            </div>
                            <span v-if="item.showRecall" 
                                @click="handleRecall(item.id)"
                                class="recall-btn">
                                撤回
                            </span>
                        </div>
                        <div v-if="item.type == 'file'" class="file xx" style="margin-right: 10px;">
                            <div class="file_flex">
                                <div class="imgs">
                                    <img src="../../assets/tim/fs.png" alt="">
                                </div>
                                <div>
                                    <div class="filename">{{ item.fileName | urlCode }}</div>
                                    <div class="filesize"> {{ item.fileSize }} </div>
                                </div>
                                <span v-if="item.showRecall" 
                                    @click="handleRecall(item.id)"
                                    class="recall-btn">
                                    撤回
                                </span>
                            </div>
                            <div class="isread" :class="item.read ? '' : 'cobule'">
                                {{ item.read ? "已读" : "未读" }}
                            </div>
                        </div>

                        <div v-if="item.type == 'image'" class="img" style="margin-right: 10px;">
                            <el-image :preview-src-list="[item.contactText]"
                                style="width: 160px;height: 160px;border-radius: 6px;"
                                :src="item.contactText"></el-image>
                            <div class="isread" :class="item.read ? '' : 'cobule'">
                                {{ item.read ? "已读" : "未读" }}
                            </div>
                            <span v-if="item.showRecall" 
                                @click="handleRecall(item.id)"
                                class="recall-btn">
                                撤回
                            </span>
                        </div>
                        <div v-if="item.type == 'link_text'" class="xx">
                            <div  v-html="item.contactText"  style="margin-right: 10px;">
                            </div>
                            <span v-if="item.showRecall" 
                                @click="handleRecall(item.id)"
                                class="recall-btn">
                                撤回
                            </span>
                            <div class="isread" :class="item.read ? '' : 'cobule'">
                                {{ item.read ? "已读" : "未读" }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="show" width="80%" center :modal="false" :show-close="false">
            <div class="fileitmes" v-for="(item, index) in waitFileList" :key="index">
                <div style="display: flex;align-items: center;">
                    <img :src="item.fileUrl" alt="" srcset="">
                    <div style="margin-left: 10px;">
                        <div class="f1">
                            <div class="warp" v-if="item.filehz[0].length > 20">
                                <div class="content">
                                    {{ item.filehz[0] }}
                                </div>
                                <div class="overflow" :data="item.filehz[0]">
                                    {{ item.filehz[0] }}
                                </div>
                            </div>
                            <div v-else>
                                {{ item.filehz[0] }}
                            </div>
                            <div>.{{ item.filehz[1] }}</div>
                        </div>
                        <div class="f2">{{ item.fileSize }}</div>
                    </div>
                </div>
                <div v-if="item.progress != 0" style="flex: 1;">
                    <el-progress :width="40" type="circle" :percentage="item.progress"></el-progress>
                </div>
            </div>
        </el-dialog>
        <div style="height: 60px;">
        </div>
        <div class="inputs">
            <el-input enterkeyhint="send" @keydown.enter.native="sendmessage(message, $event)" v-model="message"
                type="textarea" ref="input" placeholder="请输入内容" autosize></el-input>
            <div class="btn" @click="getFile">文件</div>
            <input type="file" multiple ref="file" style="display: none;" v-on:change="handleDrop($event)">
        </div>
    </div>
</template>

<script>
import { getOsstoken, getUserOrderList, jhaoyou, shaoyou } from '@/api/index'
import { createSession, sendmesg, judgeSendMsg } from '@/api/txim'
import { mapState } from 'vuex'
import OSS from 'ali-oss';
export default {
    name: '',
    data() {
        return {
            show: false,
            title: '',
            wordList: [],
            isCompleted: true,
            concatShow: true,
            nowUserID: '',
            message: '',
            noticTtype: 1,

            inputheight: '',
            fileType: ["doc", "docx", "xls", "ppt",
                "txt", "pdf", 'png',
                'jpg', 'jpeg', 'zip',
                'psd', 'xlsx', 'dwg', 'ai', 'cdr', 'tiff', 'eps', 'tif', 'mp3', 'MP3', 'MP4', 'mp4','rar'],
            waitFileList: [],
            isfile: false,
            //文件上传
            limit: 2,
            imgtype: ['jpg', 'jpeg', 'gif', 'png', 'bmp', 'image', 'webp'],
            file: null,
            nowinfo:{},
            recallDuration: 600, // 撤回时间限制2分钟（120秒）
            recallCheckInterval: 1000,
            activeRecallMessages: new Set(), // 存储需要检查的消息ID
            recallTimer: null,
            timLogin:false

        }
    },
    beforeDestroy() {
        this.nowUserID = ''
        this.concatShow = true
    },
    mounted() {
        this.nowinfo = JSON.parse(localStorage.getItem('hyinfo'))
        this.title = this.nowinfo.userProfile.nick
        this.nowUserID = this.nowinfo.userProfile.userID
        this.monitor()
        if(!this.timLogin && this.tim.IsVaild)
        {
            this.tim.setMessageRead({ conversationID: `C2C${this.nowUserID}` });
            this.getSayList({ conversationID: `C2C${this.nowinfo.userProfile.userID}`, count: 15 })
            this.timLogin = true
        }
        this.initRecallCheck()
    },
    computed: {
        ...mapState(['userinfo']),
        datatype() {
            return (item) => {
                if (item.lastMessage) {
                    if(item.lastMessage.isRevoke)
                    {
                        return ''
                    }
                    let type = JSON.parse(item.lastMessage.payload.extension).dataType
                    return type
                } else {
                    return ''
                }
            }
        }
    },
    methods: {
        indexdetailOnLogin(){
            if(this.timLogin)
            {
                return;
            }
            this.tim.setMessageRead({ conversationID: `C2C${this.nowUserID}` });
            this.getSayList({ conversationID: `C2C${this.nowinfo.userProfile.userID}`, count: 15 })
            this.timLogin = true
        },
        initRecallCheck() {
            this.recallTimer = setInterval(() => {
                const now = Date.now() / 1000;
                // 只遍历需要检查的消息
                this.activeRecallMessages.forEach(id => {
                    const msg = this.wordList.find(m => m.id === id);
                    if (!msg) {
                        this.activeRecallMessages.delete(id);
                        return;
                    }
                    
                    // 计算剩余时间
                    const shouldShow = this.canRecall(msg.time)
                    if (msg.showRecall !== shouldShow) {
                        msg.showRecall = shouldShow;
                        // 如果变成不可撤回，移出检查队列
                        if (!shouldShow) {
                            this.activeRecallMessages.delete(id);
                        }
                    }
                });
            }, this.recallCheckInterval);
        },
        getSayList(options) {
            // 打开某个会话时，第一次拉取消息列表，注意！第一次拉取时不要传入 nextReqMessageID
            this.tim.getMessageList(options).then(res => {
                let messageList = res.data.messageList;
                if (res.code == 0) {
                    let wordList = messageList.map((item) => {
                        let extension = {
                            dataType : 'default',
                            fileName : '',
                            fileSize : ''
                        }
                        if(!item.isRevoke){
                            extension = JSON.parse(item.payload.extension)
                        } 
                        let obj = {
                            mineMsg: false,
                            contactText: item.payload.data,
                            read: item.isPeerRead ? true : false,
                            id: item.ID,
                            time: item.clientTime,
                            avatar: item.avatar,
                            type: extension.dataType,
                            fileName: '',
                            fileSize: '',
                            isRevoke:item.isRevoke,
                            showRecall : this.canRecall(item.clientTime),
                        }
                        if(item.from !== this.nowUserID) {
                            obj.mineMsg = true
                            if (obj.showRecall) {
                                this.activeRecallMessages.add(item.ID);
                            }
                        }

                        if(extension.dataType == 'file') {
                            obj.fileName = extension.fileName
                            obj.fileSize = extension.fileSize
                        }
                        return obj
                    });
                    let wordListOne = wordList.filter((item) => {
                        return item;
                    });
                    //从这里往下是处理对话框滚动条的js
                    if (this.concatShow && this.nowUserID != '') {
                        this.wordList = wordListOne;
                        this.scrollEvent()
                    } else {
                        for (let i = wordListOne.length - 1; i >= 0; i--) {
                            this.wordList.unshift(wordListOne[i]);
                        }
                        this.$nextTick(() => {
                            let msg = document.getElementsByClassName("tim_cont_c")[0]; // 获取对象
                            msg.scrollTop = msg.scrollHeight - this.scrollHeight; // 滚动高度
                        });
                    }
                    //这个地方是用来处理获取上一页内容的数据
                    this.nextReqMessageID = res.data.nextReqMessageID; // 用于续拉，分页续拉时需传入该字段。
                    this.isCompleted = res.data.isCompleted; // 表示是否已经拉完所有消息。isCompleted 为 true 时，nextReqMessageID 为 ""。
                }
            })
        },
        //发送文件弹窗
        monitor() {
            this.tim.on(this.TIM.EVENT.LOGIN_SUC, this.indexdetailOnLogin)
            // 监听对方发过来的消息（我这边使用的全部是自定义字段 event.data[0].payload.data全是自定义类型）
            let onMessageReceived = (event) => {
                let payload = event.data[0].payload;
                let extension = JSON.parse(event.data[0].payload.extension)
                if (event.data[0].from !== this.nowUserID) return;
                let obj = {
                        mineMsg: false,
                        contactText: payload.data,
                        read: false,
                        time: event.data[0].clientTime,
                        id: event.data[0].ID,
                        avatar: event.data[0].avatar,
                        type: extension.dataType,
                        fileName: extension.fileName,
                        fileSize: extension.fileSize,
                        isRevoke: event.data[0].isRevoke
                    };
                this.wordList.push(obj);
                if (this.nowUserID != '') {
                    //这里是我处理聊天框页面的滚动，只要有最新的数据过来就滚动条滚动到最底部
                    this.scrollEvent();
                }
            };
            // 监听对方发过来的消息
            this.tim.on(this.TIM.EVENT.MESSAGE_RECEIVED, onMessageReceived);
            // 监听消息的已读,如果已读回执之后会进入
            let onMessageReadByPeer = (event) => {
                this.wordList.forEach((item) => {
                    if (item.mineMsg) {
                        item.read = true;
                    }
                });
            };
            this.tim.on(this.TIM.EVENT.MESSAGE_READ_BY_PEER, onMessageReadByPeer);

            let onMessageRevoked = (event) => {
                const id = event.message_id
                let obj = this.wordList.find(item => { return item.id == id })
                obj.isRevoke = true
                obj.contactText = ''
                obj.type = 'default'
            }
            this.tim.on(this.TIM.EVENT.MESSAGE_REVOKED, onMessageRevoked);
        },
        goorder() {
            this.$router.push({ path: "/indexorder", query:{id:this.nowUserID.substring(2)} }).catch(() => { });
        },
        goback() {
            this.$router.go(-1)
        },
        getFile() {
            this.$refs.file.click()
        },
        handleDrop(e) {
            if (this.isfile) return
            let files;
            files = e.target.files
            if (files.length > this.limit) {
                this.handleExceed()
                return
            }
            for (let i = 0; i < files.length; i++) {
                if (this.fileType) {
                    const fileName = files[i].name.split('.');
                    const fileExt = fileName[fileName.length - 1];
                    const isTypeOk = this.fileType.indexOf(fileExt) >= 0;
                    if (!isTypeOk) {
                        this.$message(`文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`);
                        return false;
                    }
                    this.beforePush(files[i])
                }
            }
        },
        beforePush(file) {
            let obj = {
                file: file,
                fileName: file.name,
                filehz: file.name.split('.'),
                fileSize: this.getfileSize(file.size),
                fileUrl: '',
                isimg: false,
                progress: 0,
                lastModified: file.lastModified
            }
            const fileName = file.name.split('.');
            const fileExt = fileName[fileName.length - 1];
            const isTypeOk = this.imgtype.indexOf(fileExt) >= 0;
            if (!isTypeOk) {
                obj.fileUrl = require('../../assets/tim/fs.png')
                obj.isimg = false
            } else {
                this.getBase64(file).then(res => {
                    obj.fileUrl = res
                    obj.isimg = true
                })
            }
            this.waitFileList.push(obj)
            this.uploadOss()
        },
        getBase64(file) {
            return new Promise((resolve, reject) => {
                ///FileReader类就是专门用来读文件的
                const reader = new FileReader()
                //开始读文件
                //readAsDataURL: dataurl它的本质就是图片的二进制数据， 进行base64加密后形成的一个字符串，
                reader.readAsDataURL(file)
                // 成功和失败返回对应的信息，reader.result一个base64，可以直接使用
                reader.onload = () => resolve(reader.result)
                // 失败返回失败的信息
                reader.onerror = error => reject(error)
            })
        },
        getfileSize(val) {
            if (val === 0) return "0 B"
            var k = 1024;
            var sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
            let i = Math.floor(Math.log(val) / Math.log(k))
            return ((val / Math.pow(k, i)).toFixed(2) + "" + sizes[i])
        },
        handleExceed() {
            // this.$modal.msgError(`当前限制为 ${this.limit} 个文件，请重新选择文件后再上传。`);
            this.$toast(`当前限制为 ${this.limit} 个文件，请重新选择文件后再上传。`);
            this.$refs.file.value = ''
        },
        parseTime(time, pattern) {
            if (arguments.length === 0 || !time) {
                return null
            }
            const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
            let date
            if (typeof time === 'object') {
                date = time
            } else {
                if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
                    time = parseInt(time)
                } else if (typeof time === 'string') {
                    time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
                }
                if ((typeof time === 'number') && (time.toString().length === 10)) {
                    time = time * 1000
                }
                date = new Date(time)
            }
            const formatObj = {
                y: date.getFullYear(),
                m: date.getMonth() + 1,
                d: date.getDate(),
                h: date.getHours(),
                i: date.getMinutes(),
                s: date.getSeconds(),
                a: date.getDay()
            }
            const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
                let value = formatObj[key]
                // Note: getDay() returns 0 on Sunday
                if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
                if (result.length > 0 && value < 10) {
                    value = '0' + value
                }
                return value || 0
            })
            return time_str
        },
        uploadOss() {
            this.show = true
            getOsstoken().then(res => {
                if (res.code == 1) {
                    let client = new OSS({
                        secure: res.data.secure, // 上传链接返回支持https
                        region: res.data.region, // 填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
                        accessKeyId: res.data.AccessKeyId,
                        accessKeySecret: res.data.AccessKeySecret,
                        bucket: res.data.bucket, // 填写Bucket名称
                        stsToken: res.data.SecurityToken
                    });
                    this.waitFileList.forEach(item => {
                        const options = {
                            // 获取分片上传进度、断点和返回值。
                            progress: (p, cpt, res) => {
                                item.progress = Number((p * 100).toFixed(0));//进度条
                            },
                            // 目前不传Content-Type 发现会出现错误，具体原因不清除
                            headers: {
                                'Content-Type': 'Content-Type(Mime-Type)'
                            },
                            partSize: 1024 * 1024 * 1,
                        };
                        const fileName = '/uploads/' + this.parseTime(item.file.lastModifiedDate, '{y}{m}{d}/') + item.lastModified + item.fileName 
                        this.isupload = true
                        //  配置路径以及文件名称
                        client.multipartUpload(fileName, item.file, { ...options }).then(res => {
                            var newName = ''
                            let index = res.res.requestUrls[0].indexOf("?");
                            if (index == -1) {
                                newName = res.res.requestUrls[0]
                            } else {
                                newName = res.res.requestUrls[0].substring(0, index)
                            }
                            if (res.res.statusCode === 200) {
                                let obj = {
                                    fileName: item.fileName,
                                    fileSize: item.fileSize,
                                    dataType: "image"
                                }
                                const isTypeOk = this.imgtype.indexOf(item.filehz[1]) >= 0;
                                if (!isTypeOk) {
                                    obj.dataType = "file"
                                } else {
                                    obj.dataType = "image"
                                }
                                this.createMessage({
                                    data: newName,  //文字消息
                                    extension: JSON.stringify(obj),
                                })
                            }
                        }).catch((err) => {
                            console.log(err);
                        });
                    })
                    this.isfile = false
                }

            })

        },
        download(item) {
            // var a = document.createElement('a') // 创建一个<a></a>标签
            // a.href = item.contactText         //重点（如测试发现下载文件不存在/找不到，检查路径）
            // a.download = item.fileName       // 设置下载文件文件名
            // a.style.display = 'none'           // 隐藏a标签
            // document.body.appendChild(a)       // 将a标签追加到文档对象中
            // a.click()                          // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
            // a.remove()
            fetch(item.contactText).then(response => response.blob()).then(blob => {
                saveAs(blob, item.fileName); // 设置你想要的文件名
            }).catch(error => console.error('下载失败:', error));
        },
        sendmessage(message, e) {

            let obj = {
                fileName: '',
                fileSize: '',
                dataType: "default"
            }
            if (this.message == '') {
                this.$toast(`不能发送空白消息`);
                return
            }
            this.createMessage({
                data: this.message,  //文字消息
                extension: JSON.stringify(obj),
            })
            if (e) {
                e.target.blur()
            }
        },
        createMessage(payload) {
            let message = this.tim.createCustomMessage({
                to: this.nowUserID,
                conversationType: this.TIM.TYPES.CONV_C2C,
                payload,
            });
            let promise = this.tim.sendMessage(message);
            promise.then((imResponse) => {
                this.tim.setMessageRead({ conversationID: `C2C${this.nowUserID}` });
                let payload = imResponse.data.message.payload;
                let message = imResponse.data.message;
                let extension = JSON.parse(imResponse.data.message.payload.extension)
                let obj = {
                    mineMsg: true,
                    contactText: payload.data,
                    read: false,
                    time: message.clientTime,
                    id: message.ID,
                    avatar: message.avatar,
                    type: extension.dataType,
                    fileName: '',
                    fileSize: '',
                    isRevoke:message.isRevoke,
                    showRecall : this.canRecall(message.clientTime),
                };
                if (extension.dataType == 'file' || extension.dataType == 'image') {
                    obj.fileName = extension.fileName
                    obj.fileSize = extension.fileSize
                }
                if(obj.showRecall)
                {
                    this.activeRecallMessages.add(obj.id)
                }
                this.wordList.push(obj);
                this.waitFileList = this.waitFileList.filter(item => { return item.progress != 100 })
                if (this.waitFileList.length == 0) { this.show = false }
                this.message = ''
                this.scrollEvent();
                //发送完消息 先判断这个人有么有会话
                //1 有 消息发给后台携带会话id
                //2 没有 创建会话 拿到id 再发给后端消息
                if (this.Timid) {
                    this.sendmesgH(this.nowUserID.substring(2), obj)
                } else {
                    let params = {
                        user_one: this.userinfo.id, //客户
                        user_two: this.nowUserID.substring(2), //供应商
                        type: 1, //类型:1=通用 ,2=客服
                    }
                    if (this.nowUserID == 'xj1') { params.type = 2 } else { params.type = 1 }
                    createSession(params).then(res => {
                        if (res.code == 1) {
                            this.Timid = res.data.ztim_session_id
                            this.sendmesgH(this.nowUserID.substring(2), obj)

                        }
                    })
                }


            }).catch(function (imError) {
                // 发送失败
                console.warn("sendMessage error:", imError);
            });
        },
        //发送消息给后端记录
        sendmesgH(toId, item) {
            let obj = {
                ztim_session_id: this.Timid,
                type: item.type,  //消息类型:default=普通,image=图片,file=文件
                message: item.contactText,
                recipient_id: toId,
                filename: item.fileName,
                filesize: item.fileSize,
                notice_type: this.noticTtype, //1=普通，2=通知供应商发货, 4=通知供应商报价
                gys_to_user: 0,
            }
            sendmesg(obj).then(rep => {
                this.isbaoji = false
                this.isfhuo = false
                this.noticTtype = 1
            })
        },
        // 控制滚动条滚动到底部
        scrollEvent() {
            // 自动滚动到底部
            this.$nextTick(() => {
                let msg = document.getElementsByClassName("tim_cont_c")[0]; // 获取对象
                msg.scrollTop = msg.scrollHeight + 10
            });
        },
        // 监听滚动条的高度，滚动到顶部后拉取聊天数据
        scrollEventSay(e) {
            if (!this.nowUserID) return;
            this.scrollHeight = e.srcElement.scrollHeight;
            if (e.srcElement.scrollTop == 0 && !this.isCompleted) {
                this.concatShow = false;
                this.getSayList({
                    conversationID: `C2C${this.nowUserID}`,
                    //拉取上一页聊天数据必传nextReqMessageID，在拉取会话列表中有提到
                    nextReqMessageID: this.nextReqMessageID,
                    count: 15,
                });
            }
        },
        canRecall(messageTime) {
            return (Date.now() / 1000) - messageTime < this.recallDuration
        },
        // 处理撤回操作
        handleRecall(messageId) {
            this.tim.revokeMessage({message_id:messageId}).then(res => {
                console.log(res)
            })
        },
    },
}
</script>
<style lang='scss' scoped>
.inputs {
    width: 100%;
    position: fixed;
    min-height: 60px;
    bottom: 0;
    background: #fff;
    z-index: 1;
    align-items: center;
    display: flex;
    padding: 10px 10px;
    justify-content: space-between;
    box-sizing: border-box;

    ::v-deep .el-textarea__inner {
        width: 96%;
        background: #F9F9F9;
        font-size: 14px;
        padding-left: 6px;
        border-radius: 6px;
        border: none;
        min-height: 36px !important;
    }

    .btn {
        width: 80px;
        height: 36px;
        background: #FFDB0C;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        border-radius: 6px;
    }

}

.tim_cont_c {
    height: calc(100vh - 106px);
    overflow-y: auto;
    background: #F7F8FA;
    box-sizing: border-box;

    &::-webkit-scrollbar {
        width: 4px;
        height: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(144, 147, 153, 0.3);
        cursor: pointer;
        border-radius: 4px;
    }

    .icons {
        margin-top: 100px;
    }

    .tim_time {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #ADAAAA;
        text-align: center;
    }

    .tim_system {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 13px;
        color: #f05151;
        text-align: center;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .tim_revoketip{
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 13px;
        color: #6b6a6a;
        text-align: center;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .left_cont_i {
        margin: 16px;
        display: flex;
    }

    .avatar {
        width: 40px;
        height: 40px;
        border-radius: 6px;
    }

    .recall-btn {
        color: #999;
        font-size: 12px;
        margin-left: 8px;
        cursor: pointer;
        transition: color 0.3s;
        min-width: 30px;
    }

    .recall-btn:hover {
        color: #409EFF;
        text-decoration: underline;
    }

    .right_cont_i {
        margin: 16px;
        text-align: right;
    }

    .isread {
        font-size: 12px;
        position: absolute;
        bottom: 0%;
        left: -30px;
        color: #ADAAAA !important;
    }

    .cobule {
        color: rgb(78, 78, 255) !important;
    }

    .rig {
        display: flex;
        flex-direction: row-reverse;
        position: relative;
    }

    .xx {
        max-width: 70%;
        background-color: #fff;
        border-radius: 4px;
        align-items: center;
        text-align: left;
        padding: 10px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #000000;
        line-height: 22px;
        position: relative;
        white-space: pre-wrap;
        word-wrap: break-word;
        word-break: normal;
    }

    .img {
        max-width: 70%;
        border-radius: 4px;
        align-items: center;
        text-align: left;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #000000;
        line-height: 22px;
        position: relative;
    }

    .file {
        max-width: 70%;
        padding: 10px;
        background-color: #fff;
        border-radius: 4px;
        align-items: center;
        text-align: left;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #000000;
        position: relative;

        .file_flex {
            display: flex;
            align-items: center;
        }

        .imgs {
            width: 40px;
            height: 40px;
            background: #E5FCFF;
            border-radius: 5px 5px 5px 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 10px;

            img {
                width: 28px;
                height: 28px;
            }
        }

        .imgsd {
            width: 34px;
            height: 34px;
            margin-left: 20px;
            cursor: pointer;
        }

        .filename {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #000000;
        }

        .filesize {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 12px;
            color: #ADAAAA;
        }
    }

    .xx::before {
        content: '';
        position: absolute;
        left: -5px;
        width: 8px;
        height: 8px;
        transform: rotate(45deg);
        background-color: #fff;
    }

    .rig>.xx::before {
        left: unset;
        right: -5px;
    }
}

.fileitmes {
    display: flex;
    align-items: center;
    background: #F7F8FA;
    margin-bottom: 10px;
    padding: 6px 10px;
    border-radius: 10px 10px 10px 10px;
    justify-content: space-between;

    img {
        width: 30px;
        height: 30px;
    }

    .content {
        max-height: 30px;
    }

    .overflow {
        display: block;
        position: relative;
        /* 重要 重新设置背景色将原文字覆盖 */
        background: inherit;
        top: -30px;
        height: 30px;
        overflow: hidden;
        text-align: justify;
    }

    .overflow::before {
        content: attr(data);
        width: 50%;
        float: right;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        direction: rtl;
    }

    .f1 {
        width: 160px;
        display: flex;
        align-items: center;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #000000;
        line-height: 26px;
    }

    .f2 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #ADAAAA;
    }

    .warp {
        width: 125px;
        /* 需要固定展示高度 且行高应与展示高度一致 */
        line-height: 30px;
        height: 30px;
        /* 仅展示一行 */
        overflow: hidden;
        /* 重要 必须设置背景色 以在文字溢出换行时将原文字覆盖 */
        background-color: #F7F8FA;
        outline: none;
        resize: none;
    }

    .removefile {
        cursor: pointer;
    }
}
</style>